import { useDialogState } from '@/provider/dialogState'

type DialogProps = {
  contentClass?: string
  onClose?: (result?: boolean) => void
  title?: string
  cancelBtnText?: string
  nextBtnText?: string
  data?: any
}

export const useDialog = () => {
  // TODO: try it out as singleton: https://blog.soaresdev.com/reactjs-singleton-pattern/
  const {
    isOpen,
    setOpen,
    contentClass,
    setContentClass,
    title,
    setTitle,
    cancelBtnText,
    setCancelBtnText,
    nextBtnText,
    setNextBtnText,
    data,
    setData,
    onClose = () => {},
    setOnClose,
  } = useDialogState()

  const open = (props: DialogProps) => {
    setTitle(props.title ?? '')
    setCancelBtnText(props.cancelBtnText ?? '')
    setNextBtnText(props.nextBtnText ?? '')
    setData(props.data ?? '')
    setContentClass(props.contentClass ?? '')
    if (props.onClose) setOnClose(() => props.onClose)
    setOpen(true)
  }

  const close = (result: boolean = false) => {
    setOpen(false)
    onClose(result)
    return result
  }

  return {
    isOpen,
    open,
    close,
    contentClass,
    title,
    setTitle,
    cancelBtnText,
    setCancelBtnText,
    nextBtnText,
    setNextBtnText,
    data,
    setData,
    onClose,
  }
}
